export default {
  en: "Inglés",
  fr: "Francés",
  es: "Español",
  de: "Alemán",
  it: "Italiano",
  pt: "Portugués",
  ru: "Ruso",
  zh: "Chino",
  ja: "Japonés",
  ko: "Coreano",
  ar: "Árabe",
  hi: "Hindi",
  tr: "Turco",
  nl: "Holandés",
  pl: "Polaco",
  sv: "Sueco",
  da: "Danés",
  fi: "Finlandés",
  no: "Noruego",
  cs: "Checo",
  hu: "Húngaro",
  ro: "Rumano",
  bg: "Búlgaro",
  el: "Griego",
  he: "Hebreo",
  th: "Tailandés",
  vi: "Vietnamita",
  id: "Indonesio",
  ms: "Malayo",
  fa: "Persa"
};

